import { Message } from 'element-ui'

export default {
  namespaced: true,
  state: {
    signInList: [], // 签到信息列表
    answers: [] //签到考试答案
  },
  actions: {
    // 新增签到信息
    async addSignIn({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/cultivate/check',
          data: data,
          msg: '新增签到信息成功'
        },
        { root: true }
      )
      if (data[0] && data[0].checkInType === 'BQJY') {
        for (let i = 0; i < data.length; i++) {
          const item = data[i]
          const punchRes = await dispatch(
            'attendance/addAttendance',
            {
              msg: '',
              vProjectUid: item.laborCompanyUid,
              assessOrgUid: item.laborCompanyUid,
              currentDate: item.checkInTime,
              updateReason: '班前教育打卡',
              clockType: '班前教育打卡',
              isSure: '1',
              personUid: item.personUid
            },
            { root: true }
          )
          if (punchRes && punchRes.msg && String(punchRes.msg).indexOf('已打卡') >= 0) {
            Message.success('已打卡成功')
          }
        }
      }
      return res
    },
    // 删除签到信息
    async deleteSignIn({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/person/cultivate/check',
          data: { uid: uid },
          msg: '删除签到信息成功'
        },
        { root: true }
      )
      return res
    },
    // 获取签到信息列表
    async getSignInList({ rootState, commit, dispatch }, uid) {
      const pageName =
        rootState.currentStep && rootState.currentStep.step
          ? rootState.currentStep.step.slice(0, -4)
          : ''
      const currentEvent =
        (pageName && rootState.currentRow && rootState.currentRow[pageName]) ||
        (pageName && rootState.formValues && rootState.formValues[pageName]) ||
        {}
      const eventUid = uid || currentEvent.uid || ''
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/person/cultivate/checklist',
          data: { eventUid: eventUid }
        },
        { root: true }
      )
      var signInList = Array.isArray(res && res.data) ? res.data : []
      signInList.forEach((item) => {
        item.isSignIn = item.isCheckedIn === '已签到' ? true : false
        item.isSwitch = item.isQualified ? true : false
        item.phoneNum = item.phoneNum || item.phoneNumber
        item.phoneNumber = item.phoneNumber || item.phoneNum
      })
      commit(
        'baseSet',
        { module: 'signIn', key: 'signInList', value: signInList },
        { root: true }
      )
      return signInList
    },
    // 编辑签到信息
    async editSignIn({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/person/cultivate/check',
          data: data,
          msg: '编辑签到信息成功'
        },
        { root: true }
      )
      if (data[0] && data[0].checkInType === 'BQJY') {
        for (let i = 0; i < data.length; i++) {
          const item = data[i]
          const punchRes = await dispatch(
            'attendance/addAttendance',
            {
              msg: '',
              vProjectUid: item.laborCompanyUid,
              assessOrgUid: item.laborCompanyUid,
              currentDate: item.checkInTime,
              updateReason:
                item.isCheckedIn === '已签到' ? '班前教育打卡' : '班前教育修改',
              clockType: '班前教育打卡',
              isSure: item.isCheckedIn === '已签到' ? '1' : '0',
              personUid: item.personUid
            },
            { root: true }
          )
          if (
            item.isCheckedIn === '已签到' &&
            punchRes &&
            punchRes.msg &&
            String(punchRes.msg).indexOf('已打卡') >= 0
          ) {
            Message.success('已打卡成功')
          }
        }
      }
      return res
    },
    // 获取签到考试答案
    async getAnswer({ commit, dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/person/cultivate/answer',
          data: { checkInUid: uid }
        },
        { root: true }
      )
      var answers = res.data ? res.data : []
      commit(
        'baseSet',
        { module: 'signIn', key: 'answers', value: answers },
        { root: true }
      )
      return answers
    }
  }
}
